import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type Product = {
  id: string
  name: string
  icon?: string
  timestamp: number
}

type RecentProductsStore = {
  recentProducts: Product[]
  addRecentProduct: (product: Omit<Product, 'timestamp'>) => void
  clearRecentProducts: () => void
}

export const useRecentProductsStore = create(
  persist<RecentProductsStore>(
    (set) => ({
      recentProducts: [],
      addRecentProduct: (product) => {
        set((state) => {
          // Remove the product if it already exists
          const filteredProducts = state.recentProducts.filter((p) => p.id !== product.id)

          // Add the product to the beginning of the array with current timestamp
          const newProduct = { ...product, timestamp: Date.now() }

          // Keep only the most recent 3 products
          return {
            recentProducts: [newProduct, ...filteredProducts].slice(0, 3),
          }
        })
      },
      clearRecentProducts: () => set({ recentProducts: [] }),
    }),
    {
      name: 'recent-products-storage',
    }
  )
)
